'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccessiblePopOver = require('./components/AccessiblePopOver.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccessiblePopOver).default;
  }
});
Object.defineProperty(exports, 'AccessiblePopOver', {
  enumerable: true,
  get: function get() {
    return _AccessiblePopOver.AccessiblePopOver;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-pop-over/lib/index.js
// module id = 514
// module chunks = 1